/**
 * NordPass® Password Manager & Digital Vault
 *
 * Exposes the biometric-unlock page and a bundled wordlist to every origin.
 *
 * Manifest verified against version 7.8.15.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'eiaeiblijfjekdanodkjadfinkhbfgcd';

export const nordpass: ExtensionDefinition = {
  id: ID,
  name: 'NordPass® Password Manager & Digital Vault',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 8_000_000,
  notes:
    'A password manager being remotely enumerable is a meaningful privacy leak — it ' +
    'tells a site which vault to target in a phishing flow.',
  signals: [
    {
      id: 'war-biometrics-html',
      kind: 'web-accessible-resource',
      description: 'Fetch biometrics.html — the biometric unlock prompt, exposed to <all_urls>.',
      weight: 1,
      run: () => probeFetch(ID, 'biometrics.html'),
    },
    {
      id: 'war-english-words',
      kind: 'web-accessible-resource',
      description:
        'Fetch englishWords.json — the bundled wordlist used for passphrase generation.',
      weight: 0.5,
      run: () => probeFetch(ID, 'englishWords.json'),
    },
  ],
};
